import { create } from "zustand";

const ADDRESS_VIEW_MODE = {
  AUTO_COMPLETE: "autoComplete",
  ADDRESS_FORM: "addressForm",
} as const;

type ViewModeKeys = keyof typeof ADDRESS_VIEW_MODE;
type ViewModeValues = (typeof ADDRESS_VIEW_MODE)[ViewModeKeys];

interface AddressStore {
  addressViewMode: ViewModeValues;
  setAddressViewMode: (status: ViewModeValues) => void;
  autoCompleteAddress: Record<string, any> | null;
  setAutoCompleteAddress: (address: Record<string, any> | null) => void;
  mapPickerDisabled: boolean;
  setMapPickerDisabled: (status: boolean) => void;
  autocompleteAPIData: { sessionToken: string; type: string };
  setAutocompleteAPIData: (data: { sessionToken: string; type: string }) => void;
}

export const useAddressStore = create<AddressStore>((set) => ({
  addressViewMode: ADDRESS_VIEW_MODE.AUTO_COMPLETE, //-- 顯示模式
  setAddressViewMode: (status) => set({ addressViewMode: status }),

  autoCompleteAddress: null, //-- 儲存 API 抓取地址
  setAutoCompleteAddress: (address) =>
    set({
      autoCompleteAddress: address,
    }),

  mapPickerDisabled: false,
  setMapPickerDisabled: (status) => set({ mapPickerDisabled: status }),

  autocompleteAPIData: { sessionToken: "", type: "" },
  setAutocompleteAPIData: (status) => set({ autocompleteAPIData: status }),
}));
